import { color } from '@upstox/upstox-ui';

export const container: CSSFunction = () => ({
  width: '100%',
  justifyContent: 'flex-end',
  alignItems: 'center',
});

export const button: CSSFunction = ({ theme }) => ({
  backgroundColor: color(theme, 'interactive.primary.default'),
  borderRadius: '4px',
  color: color(theme, 'text.3'),
  cursor: 'pointer',
  fontSize: theme.fontSizes.s,
  fontWeight: theme.fontWeights.normal,
  lineHeight: '20px',
  padding: '8px 16px',
  gap: '4px',
  alignItems: 'center',
});

export const icon: CSSFunction = ({ theme }) => ({
  color: color(theme, 'icon3'),
  height: '12px',
  width: '12px',
});
